import { Ref, useState } from 'react';
import { faPaperPlaneTop } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

type Props = {
  inputRef?: Ref<HTMLTextAreaElement>;
  onSubmit: (text: string) => void;
};

export const AddReply = ({ inputRef, onSubmit }: Props) => {
  const [text, setText] = useState('');
  const canSubmit = text.trim().length > 0;

  const submit = () => {
    if (!canSubmit) return;
    onSubmit(text.trim());
    setText('');
  };

  return (
    <div className="flex items-end gap-2 border-t pt-5">
      <textarea
        ref={inputRef}
        value={text}
        placeholder="Message"
        rows={1}
        onChange={(event) => setText(event.target.value)}
        className="w-full resize-none rounded-md border border-[#EEEEEE] p-3"
      />
      <button
        type="button"
        aria-label="Send the reply"
        disabled={!canSubmit}
        onClick={submit}
        className="flex size-[50px] shrink-0 items-center justify-center self-end rounded-full bg-[#5F1ECC] text-white disabled:bg-[#8F94A1]"
      >
        <FontAwesomeIcon icon={faPaperPlaneTop} />
      </button>
    </div>
  );
};
